<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../../app.config";
import axios from 'axios';
import "flatpickr/dist/flatpickr.css";
import "@vueform/multiselect/themes/default.css";
import Select2 from 'vue3-select2-component';
import Swal from "sweetalert2";

export default {
    page: {
        title: "Create Refund",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role: localStorage.getItem('role'),
            title: "Create Refund",
            items: [
                {
                    text: "Create Refund",
                    href: "/",
                },
            ],

            CustomerName: '',
            CustomerId: this.$route.params.customerId || '',
            issue_date: this.getTodayDate(),
            amount: '',
            reason: '',
            PaymentDetail: [],
            listPayments: [],
            customerList: [],
            loadingRoles: false,
            loadingCustomers: false,
            showdata: false,
            inputEmpty: false,

            FromPaymentList: false,
            selectShowPay: false,
            payment_id: [],
            selectAll: false,
            NotSelect: false,
            selectMoreThanOne: false,
            selectedPaymentId: null,
        };
    },

    methods: {
        getCustomerInfo() {
            if (!this.CustomerId) {
                this.getCustomerList(); // Fetch customer list if no customerId in URL
                return;
            }
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
            axios.get(process.env.VUE_APP_AR_API_BASEURL + 'customer/getCustomerInfo/' + this.CustomerId)
                .then(response => {
                    if (response.data) {
                        this.PaymentDetail = response.data;
                        this.CustomerName = response.data.name_as_per_nric;
                        this.getListPayments();
                    } else {
                        this.messageBag = ['No customer record found.'];
                        this.CustomerName = 'Unknown Customer';
                    }
                })
                .catch(error => {
                    this.messageBag = [error.error || 'Error fetching customer info'];
                    this.CustomerName = 'Unknown Customer';
                });
        },

        getCustomerList() {
            this.loadingCustomers = true;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
            axios.get(process.env.VUE_APP_AR_API_BASEURL + 'customer/list')
                .then(response => {
                    this.loadingCustomers = false;
                    if (response.data) {
                        // Transform response to match expected format
                        this.customerList = response.data.map(customer => ({
                            id: customer.id,
                            name_as_per_nric: customer.text.split(' - ')[0] // Extract name from "name - order_id" format
                        }));
                        console.log("Transformed customerList:", this.customerList);
                    } else {
                        this.messageBag = ['No customers found.'];
                    }
                })
                .catch(error => {
                    this.loadingCustomers = false;
                    this.messageBag = [error.error || 'Error fetching customer list'];
                });
        },

        getListPayments() {
            if (!this.CustomerId) {
                return; // Don't fetch payments until a customer is selected
            }
            this.showdata = false;
            this.loadingRoles = true;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
            axios.get(process.env.VUE_APP_AR_API_BASEURL + 'refunds/' + this.CustomerId  + '/payments')
                .then(response => {
                    this.selectShowPay = true;
                    this.loadingRoles = false;
                    if (response.data) {
                        this.showdata = true;
                        this.listPayments = response.data;
                    } else {
                        this.messageBag = ['No payment records found.'];
                    }
                })
                .catch(error => {
                    this.loadingRoles = false;
                    this.selectShowPay = false;
                    this.messageBag = [error.error || 'Error fetching payments'];
                });
        },

        sanitizeInput() {
            this.amount = this.amount.replace(/[^\d.]/g, '');
            const dotIndex = this.amount.indexOf('.');
            if (dotIndex !== -1) {
                const remainingString = this.amount.slice(dotIndex + 1);
                const dotCount = (remainingString.match(/\./g) || []).length;
                if (dotCount > 0) {
                    this.amount = this.amount.slice(0, dotIndex + 1);
                }
            }
        },

        generate() {
            console.log(this.listPayments);
            if (!this.CustomerId) {
                Swal.fire({
                    title: 'Please select a customer.',
                    icon: 'warning',
                });
            } else if (this.reason === '') {
                Swal.fire({
                    title: 'Please select a reason.',
                    icon: 'warning',
                });
            } else if (this.amount === '') {
                Swal.fire({
                    title: 'Please enter an amount.',
                    icon: 'warning',
                });
            } else if (this.selectedPaymentId == null) {
                Swal.fire({
                    title: 'Please select a payment.',
                    icon: 'warning',
                });
            } else if (this.payment_id.length > 1) {
                Swal.fire({
                    title: 'Please select only one payment.',
                    icon: 'warning',
                });
            } else {
                this.createRefund();
                // if (this.minimumValue <= this.amount && this.maxValue >= this.amount) {
                // } else {
                //     Swal.fire({
                //         title: `Amount must be between RM ${this.minimumValue} and RM ${this.maxValue}.`,
                //         icon: 'warning',
                //     });
                // }
            }
        },

        createRefund(){
            Swal.fire({
                title: "Are you sure you want to create this refund?",
                icon: "info",
                showCancelButton: true,
                cancelButtonColor: "#f46a6a",
                confirmButtonColor: "#34c38f",
                confirmButtonText: "Yes, create refund",
            }).then((result) => {
                if (result.value) {
                    const posting_ = {
                        'CustomerName': this.CustomerId,
                        'issue_date': this.issue_date,
                        'reason': this.reason,
                        'amount': -parseFloat(this.amount), // Store as negative
                        'payment_id': [this.selectedPaymentId],
                    };
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
                    axios.post(process.env.VUE_APP_AR_API_BASEURL + 'refunds', posting_)
                        .then(response => {
                            if (response.status === 201 || response.status === 200) {
                                Swal.fire({
                                    title: "Refund created!",
                                    icon: "success",
                                });
                                this.getListPayments();
                            } else {
                                Swal.fire({
                                    title: "Refund failed to create!",
                                    icon: "warning",
                                });
                            }
                        }).catch(function (error) {
                            Swal.fire({
                                title: error.response.data.msj || 'Error creating refund',
                                icon: "warning",
                            });
                        });
                }
            });
        },

        getTodayDate() {
            const today = new Date();
            return today.toISOString().slice(0, 10);
        },

        formatCurrency(value) {
            let val = (value / 1).toFixed(2);
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        selectAllItems() {
            if (this.selectAll) {
                this.payment_id = this.listPayments.map(item => item.id);
            } else {
                this.payment_id = [];
            }
        },

        onPaymentUnselected(){
            this.selectedPaymentId = null;
            this.amount = '';
        },

        onPaymentSelected(id){
            const payment = this.listPayments.find(item => item.id == id);
            if(! payment) {
                return;
            }

            this.selectedPaymentId = id;
            console.log(this.selectedPaymentId == id, this.selectedPaymentId, id);
            this.amount = parseFloat(parseFloat(payment.available_amount).toFixed(2));            
        },

        onCustomerChange() {
            this.listPayments = [];
            this.payment_id = [];
            this.selectShowPay = false;
            if (this.CustomerId) {
                // Fetch customer info to update CustomerName
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
                axios.get(process.env.VUE_APP_AR_API_BASEURL + 'customer/getCustomerInfo/' + this.CustomerId)
                    .then(response => {
                        if (response.data) {
                            this.CustomerName = response.data.name_as_per_nric;
                            this.getListPayments();
                        } else {
                            this.CustomerName = 'Unknown Customer';
                        }
                    })
                    .catch(error => {
                        this.CustomerName = 'Unknown Customer';
                        console.log(error)
                    });
            } else {
                this.CustomerName = '';
            }
        },
        goBack() {
            this.$router.back();
        },
    },

    computed: {
        maxValue() {
            let sum = 0;
            for (const id of this.payment_id) {
                const item = this.listPayments.find(payment => payment.id === id);
                if (item) {
                    sum += parseFloat(item.available_amount);
                }
            }
            return sum;
        },

        minimumValue() {
            if (this.payment_id.length === 1) {
                return 0;
            }
            let min = Infinity;
            for (const id of this.payment_id) {
                const item = this.listPayments.find(payment => payment.id === id);
                if (item) {
                    const amount = parseFloat(item.available_amount);
                    if (amount < min) {
                        min = amount;
                    }
                }
            }
            return min !== Infinity ? parseFloat(min.toFixed(2)) : 0;
        },

        isCustomerReadOnly() {
            return !!this.$route.params.customerId;
        },
    },

    watch: {
        payment_id(newValue) {
            console.log(newValue);
            if (newValue.length > 1) {
                this.selectMoreThanOne = true;
            } else {
                this.NotSelect = newValue.length === 0;
                this.selectMoreThanOne = false;
            }
        },

        CustomerId(newValue) {
            console.log(newValue)
            if (!this.isCustomerReadOnly) {
                this.onCustomerChange();
            }
        },
    },

    components: {
        Layout,
        PageHeader,
        Select2,         
    },

    mounted() {
        if (this.$route.params.customerId) {
            this.CustomerId = this.$route.params.customerId;
            this.FromPaymentList = true;
            this.getCustomerInfo();
        } else {
            this.getCustomerList();
        }
    },
};
require("@/assets/css/datatable.css");
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="live-preview">
                        <div class="row gy-4">
                            <div class="col-md-6">
                                <div>
                                    <label for="basiInput" class="form-label">Customer Name <span style="color: red;">*</span></label>
                                    <input v-if="isCustomerReadOnly" type="text" class="form-control" v-model="CustomerName" readonly>
                                    <!-- <select v-else class="form-select mb-3" v-model="CustomerId" :disabled="loadingCustomers">
                                        <option value="" selected disabled>Select Customer</option>
                                        <option v-for="customer in customerList" :key="customer.id" :value="customer.id">
                                            {{ customer.name_as_per_nric }}
                                        </option>
                                    </select> -->
                                    <Select2 v-else v-model="CustomerId" :options="customerList.map((item) => ({id: item.id, text: item.name_as_per_nric}))" placeholder="Select Customer" ></Select2>                                    
                                    <div v-if="loadingCustomers" class="spinner-border text-success" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div>
                                    <label for="labelInput" class="form-label">Issue Date <span style="color: red;">*</span></label>
                                    <input type="date" class="form-control" v-model="issue_date" readonly>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div>
                                    <label for="labelInput" class="form-label">Reason <span style="color: red;">*</span></label>
                                    <select class="form-select mb-3" v-model="reason" placeholder="" required>
                                        <option value="" selected disabled>Select Reason</option>
                                        <option value="Overpayment">Overpayment</option>
                                        <option value="Customer Request">Order Canceled</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div>
                                    <label for="labelInput" class="form-label">Refund Amount (RM) <span style="color: red;">*</span></label>
                                    <input type="text" class="form-control" v-model="amount" @input="sanitizeInput" readonly>
                                    <div v-if="amount != 0 && NotSelect == true">
                                        <p style="color:red">
                                            <span v-if="selectMoreThanOne">Min Amount: RM {{ minimumValue }} &nbsp; </span>
                                            <span v-if="(maxValue != 0)"> Max Amount {{ maxValue }} </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div v-if="loadingRoles">
                        <div class="spinner-border text-success" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div v-else>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="card" v-if="selectShowPay">
                                    <div class="card-header align-items-center d-flex">
                                        <h4 class="card-title mb-0 flex-grow-1">Payment List</h4>
                                    </div>
                                    <div class="card-body">
                                        <div class="table-responsive">
                                            <table key="dtKey" class="table table-striped table-nowrap mb-0" id="example">
                                                <thead class="table-secondary">
                                                    <tr>
                                                        <th>#.</th>
                                                        <th scope="col">Payment ID</th>
                                                        <th scope="col">Payment Date</th>
                                                        <th scope="col">Amount (RM)</th>
                                                        <th scope="col">Refundable Amount (RM)</th>                                                    
                                                        <th scope="col">Payment Type</th>
                                                        <th scope="col">Description</th>
                                                        <th scope="col">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in listPayments" :key="index" class="content">
                                                        <td>
                                                            <span @click="onPaymentSelected(item.id)" v-if="item.id != selectedPaymentId" class="btn btn-primary btn-sm">
                                                                Select
                                                            </span>
                                                            <span @click="onPaymentUnselected" v-if="item.id == selectedPaymentId" class="btn btn-danger btn-sm">unselect</span>
                                                        </td>
                                                        <td>{{item.payment_id}}</td>
                                                        <td>{{item.payment_date}}</td>
                                                        <td>{{parseFloat(item.amount).toFixed(2)}}</td>
                                                        <td>{{parseFloat(item.available_amount).toFixed(2)}}</td>
                                                        <td>{{item.payment_type}}</td>
                                                        <td>{{item.payment_description}}</td>
                                                        <td>{{item.payment_status}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row g-3 justify-content-end p-3">
                    <div class="col-sm-2">
                        <div>
                            <div @click="goBack">
                                <button class="btn btn-success w-100">Cancel</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div>
                            <button type="button" @click="generate" class="btn btn-primary w-100">
                                <i class="me-2 align-bottom"></i>Create Refund
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </Layout>
</template>